import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IAntennaSelectionHeroProps extends IBaseElementProps {
	image?: IImage;
	heading?: string;
	description?: string;
}

/**
 * Antenna Selection Hero
 * @icon cover-image
 * @block
 */
const AntennaSelectionHero: React.FC<IAntennaSelectionHeroProps> = ({
	heading,
	description,
	image,
	className,
	classNames = [],
}) => (
	<div className={className || cn('antenna-selection-hero', ...classNames)}>
		<div className="antenna-selection-hero__container">
			{image && (
				<Image className="antenna-selection-hero__image" {...image} />
			)}
			<div className="antenna-selection-hero__content">
				{heading && (
					<h1 className="antenna-selection-hero__heading">
						{heading}
					</h1>
				)}
				{description && (
					<p className="antenna-selection-hero__description">
						{description}
					</p>
				)}
			</div>
		</div>
	</div>
);

export default AntennaSelectionHero;
